<template>
  <PageLayout
    title="Obecné nastavení"
    :prev="prevRoute"
    :next="true"
    @next="onNext"
  >
    <ui-section class="mb-6">
      <ui-box label="Obecné informace">
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="pageId"
              outlined
              label="Spravovaná stránka"
              :disabled="!canEdit"
              :items="pages"
              item-text="name"
              item-value="id"
              hide-details="auto"
              name="name"
              @input="isValid('pageId')"
              :error-messages="getValidationsErrors('pageId')"
            >
              <template v-slot:selection="{ item }">
                <img v-if="item.picture" :src="item.picture.data.url" />{{
                  item.name
                }}
              </template>
              <template v-slot:item="{ item }">
                <img v-if="item.picture" :src="item.picture.data.url" />{{
                  item.name
                }}
              </template>
            </v-select>
          </v-col>
          <!--          <v-col cols="12" md="6">-->
          <!--            <v-select outlined label="Instagram" :items="[]" hide-details />-->
          <!--          </v-col>-->
        </v-row>
      </ui-box>
    </ui-section>

    <ui-section
      title="Obsah propagace"
      subtitle="Vyberte položku, kterou chcete propagovat"
    >
      <div class="d-flex py-0 mb-6">
        <ui-card-btn
          v-for="pc in adsPropagationContents"
          :key="pc.value"
          small
          :active="propagationContent === pc.key"
          @click.prevent="propagationContent = pc.key"
          :icon="pc.icon"
          class="mr-4"
        >
          {{ pc.name }}
        </ui-card-btn>
      </div>

      <v-row v-if="propagationContent">
        <v-col cols="12" :md="objective ? 8 : 12">
          <ui-box>
            <v-radio-group
              v-model="objective"
              @input="isValid('objective')"
              :error-messages="getValidationsErrors('objective')"
            >
              <v-radio
                v-for="cObjective in adsCampaignObjectives"
                :key="cObjective.key"
                :disabled="!canEdit"
                :label="cObjective.name"
                :value="cObjective.key"
              ></v-radio>
            </v-radio-group>
          </ui-box>
        </v-col>
        <v-col v-if="objective" cols="12" md="4">
          <ui-box class="fill-height">
            <div class="body-1 mb-2 font-weight-bold">
              {{ findAdsCampaignObjectives(objective).name }}
            </div>
            <div>
              {{ findAdsCampaignObjectives(objective).hint }}
            </div>
          </ui-box>
        </v-col>
      </v-row>
    </ui-section>
  </PageLayout>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

import PageLayout from "@/components/page/ads/edit/PageLayout.vue"
import validation from "../../../mixins/validation"
import { required } from "vuelidate/lib/validators"

export default {
  name: "AdGeneral",
  components: {
    PageLayout,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    nextRoute: {
      type: String,
      default: null,
    },
    prevRoute: {
      type: String,
      default: null,
    },
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  mixins: [validation],
  computed: {
    ...get("enumerations", [
      "adsCallToActionTypes",
      "adsPropagationContents",
      "adsCampaignObjectives",
      "findAdsCampaignObjectives",
    ]),
    ...get("pages", ["pages"]),
    canEdit() {
      return !(this.adId || this.audienceId)
    },
  },
  data() {
    return {
      validationMessages: {
        pageId: {
          required: "Toto pole je povinné",
        },
        objective: {
          required: "Toto pole je povinné",
        },
      },
    }
  },
  validations: {
    pageId: {
      required,
    },
    objective: {
      required,
    },
  },
  methods: {
    ...call("pages", ["loadPages"]),
    onNext() {
      if (this.isValidAll()) {
        this.$router.push(this.nextRoute)
      }
    },
  },
  mounted() {
    this.loadPages()
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }

    Object.assign(this.$options.computed, {
      ...get(`${storeNamespace}/model@`, ["adId"]),
      ...get(`${storeNamespace}/model@audience`, ["audienceId"]),
      ...sync(`${storeNamespace}/model@`, ["propagationContent"]),
      ...sync(`${storeNamespace}/model@campaign`, ["objective"]),
      ...sync(`${storeNamespace}/model@creative.objectStorySpec`, ["pageId"]),
    })
  },
}
</script>
